import * as React from 'react';
import { Field } from 'redux-form';
import { compose } from 'recompose';

import { TimePicker } from 'material-ui';

const enhance = compose<any, any>();

const ComposedTimePicker: React.SFC<any> = ({ input, label, meta: { error, submitFailed }, ...custom }) => (
  <div style={{ position: 'relative' }}>
    <TimePicker
      {...input}
      {...custom}
      format="24hr"
      hintText={label}
      onChange={(_event, date) => input.onChange(date)}
      errorText={submitFailed && error ? error : null}
      textFieldStyle={{ width: '100%' }}
      cancelLabel="Zrušit"
      floatingLabelText={label}
    />
  </div>
);

export const CustomTimePicker = enhance(ComposedTimePicker);

export class TimePickerField extends Field<any> {}



// WEBPACK FOOTER //
// ./src/components/form/TimePicker/TimePicker.tsx